import React, { Component, useEffect, useRef, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { Pagination, Table } from "antd";
import noFiles from "../../../img/no-files.svg";
import notFound from "../../../img/magnigier.svg";

import Rating from "./Rating";
import 'antd/es/table/style/css';
import 'antd/es/pagination/style/css';

const SortIcon = ({ sortOrder }) => (
  <svg
    width="10"
    height="5"
    viewBox="0 0 10 5"
    fill="none"
    style={{
      transform: sortOrder === "ascend" ? "rotate(180deg)" : "none",
      transition: "transform 0.3s ease",
    }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 5L0.669873 0.499999L9.33013 0.5L5 5Z"
      fill={sortOrder ? "#2387AA" : "#879BAA"}
    />
  </svg>
);
const TableRow = ({ text }) => {
  const [isOverflowing, setIsOverflowing] = useState(false);
  const rowRef = useRef(null);

  useEffect(() => {
    if (rowRef.current) {
      const checkOverflow = () => {
        setIsOverflowing(rowRef.current.scrollHeight > rowRef.current.clientHeight);
      };

      checkOverflow();
      window.addEventListener('resize', checkOverflow);

      return () => window.removeEventListener('resize', checkOverflow);
    }
  }, [text]);

  return (
    <div className="rows">
      <span ref={rowRef} className="row-height">
        {text}
      </span>
      {isOverflowing && <span className="tooltiptext">{text}</span>}
    </div>
  );
};
function CommunicationsList({
  list,
  isSearch,
  ratingList,
  setRating,
  decline,
  toPage,
  className = "messages-list messages-list_adapt-default",
  translate,
  history,
}) {
  const [sortOrder, setSortOrder] = useState(null);
  const [sortedInfo, setSortedInfo] = useState({});
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 900);
  const [currentPage, setCurrentPage] = useState(1);
  const [expandedItems, setExpandedItems] = useState({});
  const [data, setData] = useState([]);

  const itemsPerPage = 6;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = list.slice(indexOfFirstItem, indexOfLastItem);

  const columns = [
    {
      key: "number",
      dataIndex: "number",
      width: "6%",
      /*       sorter: (a, b) => a.number - b.number,
      sortOrder: sortedInfo.columnKey === "number" ? sortedInfo.order : null, */
      title: <span>№</span>,
    },
    {
      key: "date",
      dataIndex: "date",
      width: "11%",
      /*       sorter: (a, b) => {
        // Парсим строку в дату
        const parseDate = (dateStr) => {
          const [day, month, year] = dateStr.split(".").map(Number);
          return new Date(year, month - 1, day); // Месяц в JS 0-индексный (январь = 0)
        };

        const dateA = parseDate(a.date);
        const dateB = parseDate(b.date);

        return dateA - dateB; // Сортировка по возрастанию
      },
      sortOrder: sortedInfo.columnKey === "date" ? sortedInfo.order : null, */
      title: <span>Дата создания</span>,
    },
    {
      title: "Тип обращения",
      dataIndex: "requestType",
      key: "requestType",
      width: "15%",
      /*       sorter: (a, b) => a.requestType.localeCompare(b.requestType),
      sortOrder: sortedInfo.columnKey === "requestType" ? sortedInfo.order : null, */
      title: <span>Тип обращения</span>,
      render: (text) => {
        return text ? (<TableRow text={text}/>) : null;
      },
    },
    {
      title: "Тип документа",
      dataIndex: "documentType",
      key: "documentType",
      width: "13%",
      /*       sorter: (a, b) => a.documentType.localeCompare(b.documentType),
      sortOrder: sortedInfo.columnKey === "documentType" ? sortedInfo.order : null, */
      title: <span>Тип документа</span>,
      render: (text) => {
        return text ? (<TableRow text={text}/>) : null;
      },
    },
    {
      title: "Договор",
      dataIndex: "agreement",
      key: "agreement",
      width: "28%",
      /*       sorter: (a, b) => {
        if (a.agreement === null) return 1;  // null уходит в конец
        if (b.agreement === null) return -1; // null уходит в конец
        return a.agreement.localeCompare(b.agreement);
      },
      sortOrder: sortedInfo.columnKey === "agreement" ? sortedInfo.order : null, */
      title: <span>Договор</span>,
      render: (text) => {
        return text ? (<TableRow text={text}/>) : null;
      },
    },
    {
      title: "Статус",
      dataIndex: "status",
      key: "status",
      width: "13%",
      /*       sorter: (a, b) => a.status.localeCompare(b.status),
      sortOrder: sortedInfo.columnKey === "status" ? sortedInfo.order : null, */
      title: <span>Статус</span>,
    },
    {
      title: "Оценка",
      dataIndex: "rate",
      key: "rate",
      width: "14%",
      /*       sorter: (a, b) => a.rate.RatingValue - b.rate.RatingValue,
      sortOrder: sortedInfo.columnKey === "rate" ? sortedInfo.order : null, */
      title: <span>Оценка</span>,
      render: (text) => {

        return text.CanRate || text.RatingValue ? (
          <Rating
            isCommunicationTable
            item={text}
            rating={text.RatingValue}
            status={text.status}
            ratingList={ratingList}
            setRating={setRatings(text.CommunicationId)}
            decline={() => decline(text.CommunicationId)}
            className="message__communications"
            canComment={text.CanComment}
          />
        ) : null;
      },
    },
  ];

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth < 900);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  
  useEffect(() => {
    setData(
      list.map((item, idx) => {
        return {
          number: item.Number,
          date: item.CommunicationDate,
          requestType: item.TypeName,
          documentType: item.DocumentTypeName,
          agreement: item.ContractName,
          status: item.StatusName,
          HasUnreadMessages: item.HasUnreadMessages,
          rate: {
            RatingValue: item.RatingValue,
            CanRate: item.CanRate,
            CommunicationId: item.CommunicationId,
            status: item.StatusName,
          },
          CommunicationId: item.CommunicationId, // Add CommunicationId for reference
        };
      })
    );
  }, [list]);

  const toggleDetails = (id) => {
    setExpandedItems((prevExpanded) => ({
      ...prevExpanded,
      [id]: !prevExpanded[id], // Переключаем состояние для конкретного элемента
    }));
  };

  const handleRowClick = (record) => {
    history.push(`/communications/${record.CommunicationId}`);
  };

  const handleSort = (columnKey) => {
    const newOrder = sortOrder === "ascend" ? "descend" : "ascend";
    setSortOrder(newOrder);
    setSortedInfo({ columnKey, order: newOrder });
  };
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const setRatings = (id) => {
    return (rating, comment) => {
      setRating(id, rating, comment)
    }
  }

  if (isSmallScreen) {
    return (
      <div className="page__messages-list-small">
        {currentItems.length ? (
          <div className="single-column-list">
            {currentItems.map((item) => {
              return (
                <div
                  key={item.CommunicationId}
                  className={`single-column-item ${
                    item.HasUnreadMessages ? "HasUnreadMessages" : ""
                  }`}
                  onClick={() => handleRowClick(item)}
                >
                  <div className="communications-list__wrapper">
                    <div className="communications-list__title">№ </div>
                    <div className="communications-list__subtitle">
                      {item.Number}
                    </div>
                  </div>
                  {item.CommunicationDate && (
                    <div className="communications-list__wrapper">
                      <div className="communications-list__title">
                        Дата создания:{" "}
                      </div>
                      <div className="communications-list__subtitle">
                        {item.CommunicationDate}
                      </div>
                    </div>
                  )}
                  {item.TypeName && (
                    <div className="communications-list__wrapper">
                      <div className="communications-list__title">
                        Тип обращения:{" "}
                      </div>
                      <div className="communications-list__subtitle">
                        {item.TypeName}
                      </div>
                    </div>
                  )}
                  {expandedItems[item.CommunicationId] ? (
                    <React.Fragment>
                      {item.DocumentTypeName && (
                        <div className="communications-list__wrapper">
                          <div className="communications-list__title">
                            Тип документа:{" "}
                          </div>
                          <div className="communications-list__subtitle">
                            {item.DocumentTypeName}
                          </div>
                        </div>
                      )}
                      {item.ContractName && (
                        <div className="communications-list__wrapper">
                          <div className="communications-list__title">
                            Договор:{" "}
                          </div>
                          <div className="communications-list__subtitle">
                            {item.ContractName}
                          </div>
                        </div>
                      )}
                    </React.Fragment>
                  ) : (
                    <React.Fragment></React.Fragment>
                  )}
                  {item.StatusName && (
                    <div className="communications-list__wrapper">
                      <div className="communications-list__title">Статус: </div>
                      <div className="communications-list__subtitle">
                        {item.StatusName}
                      </div>
                    </div>
                  )}
                  {/* Блок "Оценка", который показывается/скрывается */}
                  {expandedItems[item.CommunicationId] &&
                    (item.CanRate || item.RatingValue) && (
                      <div className="rating-block">
                        <div className="communications-list__title">
                          Оценка:{" "}
                        </div>

                        <Rating
                          isCommunicationTable
                          item={item}
                          isBig
                          rating={item.RatingValue}
                          status={item.StatusName}
                          ratingList={ratingList}
                          setRating={setRatings(item.CommunicationId)}
                          decline={() => decline(item.CommunicationId)}
                          className="message__communications"
                          canComment={item.CanComment}
                        />
                      </div>
                    )}
                  {/* Кнопка "Подробнее"/"Скрыть" */}
                  {(item.CanRate ||
                    item.RatingValue ||
                    item.DocumentTypeName ||
                    item.ContractName) && (
                    <div>
                      <button
                        className="communications-list__button"
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleDetails(item.CommunicationId);
                        }}
                      >
                        {expandedItems[item.CommunicationId]
                          ? "Скрыть"
                          : "Подробнее"}
                        {expandedItems[item.CommunicationId] ? (
                          <svg
                            width="10"
                            height="7"
                            viewBox="0 0 10 7"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M0.3125 5.26561L1.21875 6.17186L5 3.32061L8.78125 6.17249L9.6875 5.26624L5 0.578734L0.3125 5.26561Z"
                              fill="#2387AA"
                            />
                          </svg>
                        ) : (
                          <svg
                            width="10"
                            height="7"
                            viewBox="0 0 10 7"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M9.6875 1.73439L8.78125 0.828139L5 3.67939L1.21875 0.827515L0.3125 1.73376L5 6.42127L9.6875 1.73439Z"
                              fill="#2387AA"
                            />
                          </svg>
                        )}
                      </button>
                    </div>
                  )}
                </div>
              );
            })}
            <Pagination
              onChange={paginate}
              current={currentPage}
              pageSize={6}
              total={list.length}
            />
          </div>
        ) : (
          renderEmpty(isSearch, translate)
        )}
      </div>
    );
  }

  return list.length ? (
    <Table
      columns={columns}
      dataSource={data}
      pagination={true}
      rowClassName={(record) =>
        record.HasUnreadMessages ? "HasUnreadMessages" : ""
      }
      onChange={(_, __, sorter) => setSortedInfo(sorter)}
      showSorterTooltip={false}
      onRowClick={(record) => handleRowClick(record)}
    />
  ) : (
    renderEmpty(isSearch, translate)
  );
}

function renderEmpty(isSearch, translate) {
  return (
    <div className="page__zero-results">
      {isSearch ? (
        <div className="page__zero-results">
          <div className="info-widget">
            <div className="info-widget__head">
              <img className="info-widget__image" src={notFound} />
            </div>
            <div className="info-widget__title">
              {translate("Ничего не найдено")}
            </div>
            <div className="info-widget__message">
              {translate("Пожалуйста, повторите запрос с другими параметрами.")}
            </div>
          </div>
        </div>
      ) : (
        <div className="info-widget">
          <div className="info-widget__head">
            <img className="info-widget__image" src={noFiles} />
          </div>
          <div className="info-widget__title">
            {translate("У вас нет обращений")}
          </div>
          <div className="info-widget__message">
            {translate("Вы можете добавить новое обращение.")}
          </div>
          <div className="info-widget__footer">
            <Link
              className="info-widget__footer-btn u-btn"
              to="/communications/create"
            >
              {translate("Новое обращение")}
            </Link>
          </div>
        </div>
      )}
    </div>
  );
}
export default withRouter(CommunicationsList);
